import {
  getChannelImage,
  getChannelMemberCount,
  getChannelStatus,
  getChannelSubtitle,
  getChannelTitle,
  getIsSalesSpaceChannelType,
} from 'gcs-common/slices/channel/channelSelectors';
import { getForwardSearchInput } from 'gcs-common/slices/channelList/channelListSelectors';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import {
  getChannelInputForwardRecipientChannelId,
  getETSForwardRecipientsChannelIds,
} from 'gcs-common/slices/messageInput/messageInputSelector';
import {
  channelInputForwardRecipientChannelIdStaged,
  channelInputForwardRecipientChannelIdUnstaged,
  channelInputForwardRecipientsFromEtsChannelIdStaged,
  channelInputForwardRecipientsFromEtsChannelIdUnstaged,
} from 'gcs-common/slices/messageInput/messageInputSlice';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import checkIcon from '../../img/check_white.svg';
import Highlight from '../Highlight/Highlight';
import ImageWithStatus from '../ImageWithStatus/ImageWithStatus';
import styles from './styles.module.scss';

interface ForwardChannelListItemProps {
  channelId: string;
  forwardingFromEts?: boolean | false;
}

const ForwardChannelListItem = (props: ForwardChannelListItemProps) => {
  const { channelId, forwardingFromEts } = props;
  const dispatch = useDispatch();
  const forwardSearchInput = useSelector(getForwardSearchInput);
  const etsReciepientsIds = useSelector(getETSForwardRecipientsChannelIds);
  const selectedChannelId = useSelector(getSelectedChannelId);
  const forwardRecipientChannelIds = useSelector(getChannelInputForwardRecipientChannelId(selectedChannelId));
  const selectedChannelIds = forwardingFromEts ? etsReciepientsIds : forwardRecipientChannelIds;
  const channelTitle = useSelector(getChannelTitle(channelId));
  const channelSubtitle = useSelector(getChannelSubtitle(channelId));
  const channelImage = useSelector(getChannelImage(channelId));
  const channelStatus = useSelector(getChannelStatus(channelId));
  const isSelected = selectedChannelIds?.includes(channelId);
  const isSalesSpace = useSelector(getIsSalesSpaceChannelType(channelId));
  const isAgent = useSelector(getIsAgent);
  const channelMemberCount = useSelector(getChannelMemberCount(channelId));

  const onToggle = useCallback(() => {
    if (isSelected) {
      dispatch(
        channelInputForwardRecipientChannelIdUnstaged({
          channelId: selectedChannelId,
          recipientChannelId: channelId,
        }),
      );
    } else {
      dispatch(
        channelInputForwardRecipientChannelIdStaged({
          channelId: selectedChannelId,
          recipientChannelId: channelId,
        }),
      );
    }
  }, [channelId, dispatch, isSelected, selectedChannelId]);

  const selectChannel = useCallback(() => {
    if (isSelected) {
      dispatch(
        channelInputForwardRecipientsFromEtsChannelIdUnstaged({
          recipientChannelId: channelId,
        }),
      );
    } else {
      dispatch(
        channelInputForwardRecipientsFromEtsChannelIdStaged({
          recipientChannelId: channelId,
        }),
      );
    }
  }, [dispatch, isSelected, channelId]);

  return (
    <div
      onClick={forwardingFromEts ? selectChannel : onToggle}
      className={isSelected ? styles.selectedChannelListItem : styles.listItem}
    >
      <div className={isSelected ? styles.selectedCheckIconWrapper : styles.checkIconWrapper}>
        {isSelected && <img src={checkIcon} alt="checkme" />}
      </div>
      <ImageWithStatus
        className={styles.imageWrapper}
        imageUrl={channelImage}
        userStatus={channelStatus}
        isAgent={isAgent}
        isSalesSpace={isSalesSpace}
        channelMemberCount={channelMemberCount}
      />
      <div className={styles.content}>
        <div className={styles.customerTitle}>
          <Highlight search={forwardSearchInput}>{channelTitle}</Highlight>
        </div>
        <div className={styles.customerCompany}>
          <Highlight search={forwardSearchInput}>{channelSubtitle}</Highlight>
        </div>
      </div>
    </div>
  );
};

ForwardChannelListItem.propTypes = {
  channelId: PropTypes.string.isRequired,
};

export default ForwardChannelListItem;
